import React from "react"

const MetaPermissionsNote: React.FC = () => (
  <div className="bg-warning/10 border border-warning/30 rounded-lg p-4 mb-4">
    <p className="text-warning font-semibold text-sm mb-1">Important</p>
    <p className="text-sm leading-5 text-platinum">
      If you have previously connected a Meta product (Instagram, Facebook Ads,
      etc.), please confirm your previous settings are still correct and ensure
      you have granted the correct permissions to Marathon. Revoking or
      modifying permissions may cause data syncs to fail.
    </p>
  </div>
)

export default MetaPermissionsNote
